exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".color-editor{position:absolute;z-index:100;display:flex;flex-direction:column;align-items:center;left:-532px;top:0;background-color:#101012;border:2px solid #c7c7c7;padding:8px}.color-editor .photoshop-picker{color:initial}.color-editor .btn{margin-top:8px}", ""]);

